<div class="question-type__text">
  <h1 class="fs__xxl">Heatmap</h1>
  <p class="fs__md">Participants click on areas of an image to provide feedback. Useful for testing visual designs, user experience, and product placements.</p>
  <ul class="question-type__bullet-points">
    <li class="fs__sm">
      <span class="sub-text">You can select a minumum and maximum number of areas that the participant has to pick.</span>
    </li>
    <li class="fs__sm">
      <span class="sub-text">You can specify the size and aspect ratio of the image that you upload.</span>
    </li>
    <li class="fs__sm">
      <span class="sub-text">Images can be PNG or JPG format</span>
    </li>
  </ul>
  <h2 class="fs__lg">Example</h2>
  <p class="fs__md">Please select the areas of the image that you find most appealing. You can select up to 3 locations.</p>
</div>
